import { render, staticRenderFns } from "./ClientsPartner.vue?vue&type=template&id=2475965a&"
import script from "./ClientsPartner.vue?vue&type=script&lang=js&"
export * from "./ClientsPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2475965a')) {
      api.createRecord('2475965a', component.options)
    } else {
      api.reload('2475965a', component.options)
    }
    module.hot.accept("./ClientsPartner.vue?vue&type=template&id=2475965a&", function () {
      api.rerender('2475965a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientsPartner.vue"
export default component.exports